module.exports = __webpack_public_path__ + "assets/img/ghelp.5bce2ce7.png";